<template>
  <v-dialog v-model="bShowExport" hide-overlay persistent width="600">
    <v-card>
      <v-card-title class="titleslight--text">
        Generar archivo Excel
        <v-spacer></v-spacer>
      <v-icon class="ma-2" color="primary" text @click="CloseDialog()">fas fa-times</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="center" dense>
            <v-col sm="6" md="6" lg="6" xl="6">
              <v-menu
                ref="desde"
                v-model="desde"
                :close-on-content-click="false"
                :return-value.sync="datedesde"
                transition="scale-transition"
                offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="datedesde"
                    label="Desde"
                    prepend-icon="fas fa-calendar-alt"
                    readonly
                    :rules="aValidateDesde"
                    v-bind="attrs"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="datedesde"
                  no-title
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="desde = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.desde.save(datedesde)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="6" md="6" lg="6" xl="6">
              <v-menu
                ref="hasta"
                v-model="hasta"
                :close-on-content-click="false"
                :return-value.sync="datehasta"
                transition="scale-transition"
                offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="datehasta"
                    label="Hasta"
                    prepend-icon="fas fa-calendar-alt"
                    readonly
                    :rules="aValidateHasta"
                    v-bind="attrs"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="datehasta"
                  no-title
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="hasta = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.hasta.save(datehasta)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
        <v-progress-linear
          active
          :indeterminate="bFinish"
          color="primary"
          class="mb-0"
          height="20"
          rounded>
          <strong>{{ sLabel }}</strong>
        </v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-btn
          outlined
          small
          color="primary"
          class="ma-2"
          :disabled="bGenerate"
          @click="getForm()">
          <v-icon x-small left dark>fa-file-excel</v-icon>
          Generar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          small
          color="primary"
          class="ma-2"
          :disabled="!bGenerate"
          @click="onExport()">
          <v-icon x-small left dark>fas fa-cloud-download-alt</v-icon>
          Descargar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import XLSX from 'xlsx'
import axiosServices from '@/services/axiosServices.js'
export default {
  name: 'ExportExcelDinamicos',
  props: {
    bShowExport: {
      type: Boolean,
      default: false
    },
    TypeExport: {
      type: String,
      default: 'xlsx'
    },
    nIdForm: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      json_meta   : [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      sLabel  : '',
      bFinish : false,
      bGenerate: false,
      nameArchive : '',
      aHeadersForm: [],
      aItemsForm: [],
      aHeadersSubForm : [],
      aItemsSubForm: [],
      datedesde: '',
      datehasta: '',
      desde: false,
      hasta: false,
      aValidateDesde: [
        v => !!v || 'La fecha desde es requerida.'
      ],
      aValidateHasta: [
        v => !!v || 'La fecha hasta es requerida.',
        v => Date.parse(v) >= Date.parse(this.datedesde) || 'La fecha hasta no puede ser menor a la fecha desde'
      ]
    }
  },
  methods: {
    getForm() {
      if (this.datedesde !== "" && this.datehasta !== "") {
        this.sLabel =  'Generando...'
        this.bFinish = true
        let sParam = `idNombreForm=${this.nIdForm}&datedesde=${this.datedesde}&datehasta=${this.datehasta}`
        axiosServices.getConfiguration('/dinamicgridnew_getForm', true, sParam).then(aDataExport => {
          if (aDataExport.nStatusCode == 200) {
            this.aHeadersForm = aDataExport.aData.headers
            this.aItemsForm = aDataExport.aData.information
            this.getSubFormularios()
          } else {
            this.$store.dispatch('SetMensaje', `${aDataExport.sMessage}`)
            this.$store.dispatch('ShowNotificacion', true)
          }
        })
      } else {
        this.$store.dispatch('SetMensaje', 'Debe seleccionar un rango de fecha')
        this.$store.dispatch('ShowNotificacion', true)
      }
    },
    getSubFormularios() {
      let sParam = `idNombreForm=${this.nIdForm}&datedesde=${this.datedesde}&datehasta=${this.datehasta}`
      axiosServices.getConfiguration('/dinamicgridnew_getSub', true, sParam).then(aDataExport => {
        if (aDataExport.nStatusCode == 200) {
          this.aHeadersSubForm = aDataExport.aData.headers
          this.aItemsSubForm = aDataExport.aData.information
          this.bFinish = false
          this.bGenerate = true
          this.sLabel = "Listo para descargar!"
        } else {
          this.$store.dispatch('SetMensaje', `${aDataExport.sMessage}`)
          this.$store.dispatch('ShowNotificacion', true)
        }
      })
    },
    onExport () { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      var SheetForm = XLSX.utils.json_to_sheet(this.aItemsForm, {header: this.aHeadersForm})
      var SheetSubForm = XLSX.utils.json_to_sheet((typeof this.aItemsSubForm == "object") ? Object.values(this.aItemsSubForm) : this.aItemsSubForm, {header: this.aHeadersSubForm})
      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, SheetForm, 'Formulario Principal')// sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, SheetSubForm, 'Subformulario')// sheetAName is name of Worksheet
      // export Excel file
      XLSX.writeFile(wb, `${this.nameArchive}_${this.datedesde}_a_${this.datehasta}.${this.TypeExport}`) // name of the file
      this.CloseDialog()
    },
    CloseDialog() {
      this.datedesde = ""
      this.datehasta = ""
      this.$emit('input', false)
    }
  },
  watch: {
    bShowExport(bNewValue) {
      if (bNewValue == true) {
        this.nameArchive = 'Formdinamic'
      }
    },
  }
}
</script>